import {
  defaultTabKey,
  type WorkspaceTabSpec,
} from "@src/features/agenticCodegen/workspace/domainConfig";

import type { AgenticLogicTabKey } from "./types";

/**
 * The bottom-section tab keys, in display order. The rule workspace mounts
 * with no bottom tabs (`buildAgenticDomainConfig` passes `tabs: []`) — the
 * suites the Publish gates tab used to hold are files in the editor — so this
 * exists to name the default tab the workspace hook opens on.
 */
export const AGENTIC_LOGIC_WORKSPACE_TABS: readonly AgenticLogicTabKey[] = [
  "publish_gates",
];

/**
 * The first available tab — Publish gates today. Computed with the shell's
 * own helper rather than named literally, so this agrees with the shell's
 * rule. The `render` below is never mounted; it exists only because the
 * helper takes full specs.
 */
export const AGENTIC_LOGIC_DEFAULT_TAB: AgenticLogicTabKey = defaultTabKey(
  AGENTIC_LOGIC_WORKSPACE_TABS.map(
    (key): WorkspaceTabSpec<AgenticLogicTabKey> => ({
      key,
      label: key,
      availability: { kind: "enabled", render: () => null },
    })
  )
);
